function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M28.868 1.987H1.132M28.868 9.5H1.132m27.736 7.513H1.132",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19
  }, props), _ref);
}

export default SvgMenu;